import { _ as _createClass, a as _classCallCheck } from '../../createClass-DV1OmW3s.js';
import { _ as _defineProperty } from '../../defineProperty-DmV7cVMj.js';
import IS_BROWSER from '../../isBrowser/index.js';
import generateUUID from '../../generateUUID/index.js';
import storageApi from '../storage/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var gtmID = 'gtmID';
var AnalyticsEnum = /*#__PURE__*/function (AnalyticsEnum) {
  AnalyticsEnum["gtag"] = "gtag";
  AnalyticsEnum["internal"] = "internal";
  return AnalyticsEnum;
}({});
var AnalyticsService = /*#__PURE__*/function () {
  function AnalyticsService() {
    _classCallCheck(this, AnalyticsService);
    _defineProperty(this, "tagManagerArgs", undefined);
    _defineProperty(this, "module", undefined);
    _defineProperty(this, "analyticsType", undefined);
    _defineProperty(this, "tagManagerModule", null);
    _defineProperty(this, "tagManagerModulePromise", null);
    _defineProperty(this, "campaignShortMap", new Map([['retargeting', 'rt'], ['specialoffer', 'sp']]));
  }
  return _createClass(AnalyticsService, [{
    key: "getPackageId",
    value: function getPackageId(frequency, type) {
      var typesMap = new Map([['student', '_student_discount'], ['teams', '_teams']]);
      return "com.picsart.www.subscription_".concat(frequency).concat(typesMap.get(type) || '');
    }
  }, {
    key: "importTagManagerModule",
    value: function importTagManagerModule(cb) {
      var _this = this;
      if (this.tagManagerModule) {
        cb(this.tagManagerModule);
      } else {
        if (!this.tagManagerModulePromise) {
          this.tagManagerModulePromise = import('react-gtm-module').then(function (_ref) {
            var TagManager = _ref["default"];
            _this.tagManagerModule = TagManager;
            return _this.tagManagerModule;
          });
        }
        this.tagManagerModulePromise.then(cb);
      }
    }
  }, {
    key: "init",
    value: function init(analyticsId, moduleId) {
      var _this2 = this;
      var dataLayerName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dataLayer';
      var analyticsType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : AnalyticsEnum.gtag;
      var gtmDelay = arguments.length > 4 ? arguments[4] : undefined;
      localStorage.removeItem('A_E');
      if (analyticsType === AnalyticsEnum.gtag) {
        this.module = moduleId;
        this.tagManagerArgs = {
          gtmId: analyticsId,
          dataLayerName: dataLayerName
        };
        this.analyticsType = analyticsType;
        setTimeout(function () {
          return _this2.importTagManagerModule(function (TagManager) {
            TagManager.initialize(_this2.tagManagerArgs);
          });
        }, gtmDelay);
      } else if (analyticsType === AnalyticsEnum.internal) {
        this.analyticsType = analyticsType;
      }
    }

    // TODO: later we need to define more types and remove `object`
  }, {
    key: "dataLayer",
    value: function dataLayer(newLayer) {
      var _this3 = this;
      var layer = _objectSpread({}, newLayer);
      var _ref2 = layer,
        event = _ref2.event,
        eventCallback = _ref2.eventCallback;
      if (event === 'custom_event' || event === 'custom_event_non_interaction') {
        var uuid = generateUUID();
        layer.data.id = uuid;
        // @ts-ignore
        layer.data.filterId = layer.event + layer.data.action;
      }
      // @ts-ignore
      layer.eventCallback = function (id) {
        var containerId = storageApi.getSync('', gtmID);
        id === containerId && (eventCallback === null || eventCallback === undefined ? undefined : eventCallback());
      };
      if (IS_BROWSER && this.analyticsType === AnalyticsEnum.gtag) {
        this.importTagManagerModule(function (TagManager) {
          var _this3$tagManagerArgs;
          TagManager.dataLayer({
            dataLayerName: (_this3$tagManagerArgs = _this3.tagManagerArgs) === null || _this3$tagManagerArgs === undefined ? undefined : _this3$tagManagerArgs.dataLayerName,
            dataLayer: layer
          });
        });
      } else if (this.analyticsType === AnalyticsEnum.internal) {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push(layer);
      }
    }
  }, {
    key: "trackCustomEvent",
    value: function trackCustomEvent(action, event, data, callback, priority) {
      this.dataLayer({
        event: event,
        data: {
          module: this.module,
          action: action,
          parameters: data
        },
        eventCallback: function eventCallback() {
          callback && callback();
        },
        eventTimeout: 2000,
        event_priority: priority
      });
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(action, data, callback, priority) {
      this.trackCustomEvent(action, 'custom_event', data, callback, priority);
    }
  }, {
    key: "sendEventNonInteraction",
    value: function sendEventNonInteraction(action, data, priority) {
      this.trackCustomEvent(action, 'custom_event_non_interaction', data, null, priority);
    }
  }, {
    key: "pushDataLayer",
    value: function pushDataLayer(dataLayer) {
      this.dataLayer(dataLayer);
    }
  }, {
    key: "pageView",
    value: function pageView(page) {
      this.dataLayer({
        event: 'page_view',
        pagePath: page
      });
    }
  }, {
    key: "getFlowByCampaign",
    value: function getFlowByCampaign(campaign) {
      if (!campaign) {
        return 'default';
      }
      var name = campaign.name,
        number = campaign.number,
        scope = campaign.scope;
      if (!name) {
        return scope;
      }
      return "".concat(this.campaignShortMap.get(name)).concat(number || '', "-").concat(scope);
    }
  }]);
}();
var AnalyticsService$1 = new AnalyticsService();

export { AnalyticsEnum, AnalyticsService$1 as default };
//# sourceMappingURL=index.js.map
